import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/main.css";
import "./components/course-details/ManageContent.css";
import "./components/course-details/courseMedia.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./assets/css/ChatMod.scss";
import "./assets/css/upload.css";
import "./assets/css/Profile.scss";
import "./assets/css/feed.css";
import "./assets/css/page-layout.css";
import "./components/agenda/AgendaFoundation.css";
import "../src/pages/auth/newauth/NewLogin.css";
// import * as Sentry from "@sentry/react";

// Sentry.init({
//   dsn: "https://34ce04db59051067e38d5d048a21b088@o4510157244792832.ingest.de.sentry.io/4510163362119760",
//   environment: import.meta.env.REACT_APP_ENV,
//   sendDefaultPii: true,
//   _experiments: { enableLogs: true },
//   integrations: [Sentry.httpClientIntegration()]
// });
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode >
    <App />
 </React.StrictMode>
);
reportWebVitals();
